var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointIcon3Itsumoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 54.9962C110 24.623 85.3709 0 54.9926 0C24.6214 0 0 24.623 0 54.9962C0 85.3765 24.6214 110 54.9926 110C85.3709 110 110 85.3765 110 54.9962Z",
    fill: "#28AF06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4639 89.0952C39.3564 88.9854 39.2442 88.89 39.1367 88.8096C39.0243 88.7314 38.8632 88.6338 38.6532 88.5263C39.5346 88.0355 39.9765 87.2811 39.9765 86.2607C39.9765 85.8114 39.8984 85.4061 39.7421 85.0449C39.5859 84.6836 39.3662 84.376 39.0829 84.1221C38.7973 83.8682 38.4481 83.6704 38.0379 83.5313C37.6278 83.3897 37.1737 83.3213 36.6756 83.3213H32.3835V94H36.8562C37.3543 94 37.8084 93.9268 38.2137 93.7827C38.619 93.6386 38.9607 93.4336 39.2489 93.1674C39.5321 92.9013 39.7493 92.5839 39.8982 92.2079C40.0496 91.8319 40.1253 91.4096 40.1253 90.9383C40.1253 90.5599 40.074 90.2205 39.9665 89.9202C39.8618 89.6202 39.6934 89.3468 39.4639 89.0952ZM34.4687 85.1818H36.5098C36.9395 85.1818 37.2764 85.2893 37.5229 85.5089C37.7671 85.7286 37.8915 86.0314 37.8915 86.4099C37.8915 86.7908 37.767 87.091 37.5229 87.3108C37.2764 87.5305 36.9395 87.6404 36.5098 87.6404H34.4687V85.1818ZM37.6645 91.7882C37.4131 92.0225 37.076 92.1397 36.6464 92.1397H34.4687V89.5152H36.6465C37.0762 89.5152 37.4131 89.6299 37.6646 89.8594C37.9162 90.0889 38.0382 90.4111 38.0382 90.8213C38.0382 91.2314 37.916 91.5538 37.6645 91.7882Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4707 83.3213L42.584 94H44.7593L45.4062 92.1104H49.2001L49.8301 94H52.0029L48.104 83.3213H46.4707ZM45.9896 90.355L47.3398 86.4708L48.6435 90.355H45.9896Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9141 89.8594L56.6857 83.3213H54.8252V94H56.9102V87.4449L61.1388 94H62.9991V83.3213H60.9141V89.8594Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3599 83.3213H72.8233L69.0586 87.9697V83.3213H66.9736V94H69.0586V90.7896L70.4405 89.1416L73.1846 94H75.6163L71.8199 87.5646L75.3599 83.3213Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14L24 24.835V31.085H26.5V32.96H81.5V31.085H84V24.835L54 14Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 69.835H26.5V74.835H24V79.835H84V74.835H81.5V69.835Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.75 64.835V67.335H77.75V64.835H76.5V37.96H77.75V35.46H67.75V37.96H69V64.835H67.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49 64.835V67.335H59V64.835H57.75V37.96H59V35.46H49V37.96H50.25V64.835H49Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 64.835V67.335H40.25V64.835H39V37.96H40.25V35.46H30.25V37.96H31.5V64.835H30.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointIcon3Itsumoni);
export default __webpack_public_path__ + "static/media/point_icon3_itsumoni.6121a07de6c064b8fc6153612d476b2a.svg";
export { ForwardRef as ReactComponent };